<section class="adjust-hit-overview">
  <section class="header">
    <span class="title">Adjust Hit Overview </span>
    <button
      mat-icon-button
      mat-dialog-close
      class="material-icons floatRight close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </section>
  <mat-divider></mat-divider>
  <div class="hit-overview-columns-container">
    <app-hit-overview-columns
      [columns]="columns"
      (columnChanged)="columns = $event"
    ></app-hit-overview-columns>
  </div>
  <mat-divider class="divider"></mat-divider>
  <div class="button-container">
    <button
      id="apply-hit-overview-changes"
      mat-flat-button
      color="primary"
      class="apply-button"
      color="primary"
      (click)="saveHitOverView()"
    >
      Apply
    </button>
  </div>
</section>
